import LegalPage from "@/components/LegalPage";

export default function ShippingPolicy() {
  return (
    <LegalPage title="Delivery & Fulfilment." updated="Feb 2026" testId="shipping-page">
      <p>Carpe Diem Goa primarily provides in-person experiences at our premises in Majorda, South Goa. This policy explains how our various offerings are fulfilled.</p>

      <h2>1. Workshops, classes, performances & exhibitions</h2>
      <p>All programmes take place at our physical venue: H. No. 81/2, Godinho House, Gomes Waddo, Majorda, South Goa 403713.</p>
      <p>Once payment is confirmed, you receive an email with your booking ID. There is no physical ticket to ship. Please present the confirmation email or booking ID on arrival.</p>

      <h2>2. Artworks (Buy Art)</h2>
      <p>Artworks purchased through our Buy Art programme are handled case-by-case, as each piece is unique in size, weight and fragility.</p>
      <ul>
        <li><strong>Local pickup (Goa):</strong> free — you or your representative can collect the piece from our gallery in Majorda by prior appointment.</li>
        <li><strong>Domestic shipping (India):</strong> quoted individually based on size, framing and destination. Typical timing 5-10 business days, using insured carriers such as BlueDart or DTDC.</li>
        <li><strong>International shipping:</strong> arranged on request via professional fine-art shippers. Customer bears customs duties and any applicable taxes in the destination country.</li>
      </ul>
      <p>A shipping quote will be sent to you within 2 business days of purchase for your approval before we dispatch.</p>

      <h2>3. Cafe & studio consumables</h2>
      <p>Food, beverages and studio-consumable purchases are for on-premises consumption only. We do not offer delivery.</p>

      <h2>4. Damaged or lost items</h2>
      <p>If a shipped artwork arrives damaged, please email <a href="mailto:info@carpediemgoa.com">info@carpediemgoa.com</a> with photos within 48 hours of receipt. We will work with the shipper to file a claim and make good.</p>

      <h2>5. Contact</h2>
      <p>Any questions about fulfilment or delivery: <a href="mailto:info@carpediemgoa.com">info@carpediemgoa.com</a> or +91 98225 80152 (WhatsApp).</p>
    </LegalPage>
  );
}
